import { m } from 'framer-motion';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import CompactLayout from 'src/layouts/compact';
import { SeverErrorIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';

// ----------------------------------------------------------------------

const SUPPORT_EMAIL = 'hello@voolist.com';

export default function ErrorView ({ error, showContactOptions, onRetry }) {
  return (
    <CompactLayout>
      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Something went wrong
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            {error}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <SeverErrorIllustration
            sx={{
              height: 260,
              my: { xs: 5, sm: 10 },
            }}
          />
        </m.div>

        <Stack spacing={2} alignItems="center">
          <Button
            size="large"
            variant="contained"
            onClick={onRetry || (() => window.location.reload())}
          >
            Try again
          </Button>

          {showContactOptions && (
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
                Still having trouble? We&apos;re here to help.
              </Typography>

              <Stack direction="row" spacing={2} justifyContent="center">
                <Button
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    if (window.$crisp) {
                      window.$crisp.push(['do', 'chat:open']);
                    } else if (window.Intercom) {
                      window.Intercom('show');
                    } else {
                      window.location.href = `mailto:${SUPPORT_EMAIL}`;
                    }
                  }}
                >
                  Chat with us
                </Button>

                <Button
                  variant="outlined"
                  size="medium"
                  href={`mailto:${SUPPORT_EMAIL}`}
                  component={Link}
                >
                  Email Us
                </Button>
              </Stack>
            </Box>
          )}
        </Stack>
      </MotionContainer>
    </CompactLayout>
  );
}

ErrorView.propTypes = {
  error: PropTypes.string.isRequired,
  showContactOptions: PropTypes.bool,
  onRetry: PropTypes.func,
};
